import { POST_FAQ_START } from '../../types';

export const post_faqs = (payload) => ({
  type: POST_FAQ_START,
  payload,
});
